module.exports = __webpack_public_path__ + "static/media/c4.6d73bbde.jpg";